window.Noty.overrideDefaults({
    layout: 'topRight',
    theme: 'bootstrap-v4',
    timeout: 5000,
    closeWith: ['click', 'button'],
});
